"use client";
var t = /* @__PURE__ */ (function(n) {
  return n.DOCUMENT = "document", n.PARAGRAPH = "paragraph", n.HEADING_1 = "heading-1", n.HEADING_2 = "heading-2", n.HEADING_3 = "heading-3", n.HEADING_4 = "heading-4", n.HEADING_5 = "heading-5", n.HEADING_6 = "heading-6", n.OL_LIST = "ordered-list", n.UL_LIST = "unordered-list", n.LIST_ITEM = "list-item", n.HR = "hr", n.QUOTE = "blockquote", n.EMBEDDED_ENTRY = "embedded-entry-block", n.EMBEDDED_ASSET = "embedded-asset-block", n.EMBEDDED_RESOURCE = "embedded-resource-block", n.TABLE = "table", n.TABLE_ROW = "table-row", n.TABLE_CELL = "table-cell", n.TABLE_HEADER_CELL = "table-header-cell", n;
})({}), i = /* @__PURE__ */ (function(n) {
  return n.ASSET_HYPERLINK = "asset-hyperlink", n.EMBEDDED_ENTRY = "embedded-entry-inline", n.EMBEDDED_RESOURCE = "embedded-resource-inline", n.ENTRY_HYPERLINK = "entry-hyperlink", n.HYPERLINK = "hyperlink", n.RESOURCE_HYPERLINK = "resource-hyperlink", n;
})({});
const f = [
  t.PARAGRAPH,
  t.HEADING_1,
  t.HEADING_2,
  t.HEADING_3,
  t.HEADING_4,
  t.HEADING_5,
  t.HEADING_6,
  t.OL_LIST,
  t.UL_LIST,
  t.HR,
  t.QUOTE,
  t.EMBEDDED_ENTRY,
  t.EMBEDDED_ASSET,
  t.EMBEDDED_RESOURCE,
  t.TABLE
], d = [
  t.PARAGRAPH,
  t.HEADING_1,
  t.HEADING_2,
  t.HEADING_3,
  t.HEADING_4,
  t.HEADING_5,
  t.HEADING_6,
  t.OL_LIST,
  t.UL_LIST,
  t.HR,
  t.QUOTE,
  t.EMBEDDED_ENTRY,
  t.EMBEDDED_ASSET,
  t.EMBEDDED_RESOURCE
];
t.TABLE, t.TABLE_ROW, t.TABLE_CELL, t.TABLE_HEADER_CELL;
t.HR, t.EMBEDDED_ENTRY, t.EMBEDDED_ASSET, t.EMBEDDED_RESOURCE;
const I = {
  [t.OL_LIST]: [
    t.LIST_ITEM
  ],
  [t.UL_LIST]: [
    t.LIST_ITEM
  ],
  [t.LIST_ITEM]: d,
  [t.QUOTE]: [
    t.PARAGRAPH
  ],
  [t.TABLE]: [
    t.TABLE_ROW
  ],
  [t.TABLE_ROW]: [
    t.TABLE_CELL,
    t.TABLE_HEADER_CELL
  ],
  [t.TABLE_CELL]: [
    t.PARAGRAPH,
    t.UL_LIST,
    t.OL_LIST
  ],
  [t.TABLE_HEADER_CELL]: [
    t.PARAGRAPH
  ]
}, H = [
  t.HEADING_1,
  t.HEADING_2,
  t.HEADING_3,
  t.HEADING_4,
  t.HEADING_5,
  t.HEADING_6
];
[
  t.PARAGRAPH,
  ...H
];
t.DOCUMENT, t.PARAGRAPH, t.HEADING_1, t.HEADING_2, t.HEADING_3, t.HEADING_4, t.HEADING_5, t.HEADING_6, t.OL_LIST, t.UL_LIST, t.LIST_ITEM, t.HR, t.QUOTE, t.EMBEDDED_ENTRY, t.EMBEDDED_ASSET, i.HYPERLINK, i.ENTRY_HYPERLINK, i.ASSET_HYPERLINK, i.EMBEDDED_ENTRY;
t.DOCUMENT, t.PARAGRAPH;
const T = ({ path: n, property: e, typeName: r, value: s }) => ({
  details: `The type of "${e}" is incorrect, expected type: ${r}`,
  name: "type",
  path: n.toArray(),
  type: r,
  value: s
}), N = ({ min: n, value: e, path: r }) => ({
  name: "size",
  min: n,
  path: r.toArray(),
  details: `Size must be at least ${n}`,
  value: e
}), y = ({ max: n, value: e, path: r }) => ({
  name: "size",
  max: n,
  path: r.toArray(),
  details: `Size must be at most ${n}`,
  value: e
}), b = ({ expected: n, value: e, path: r }) => ({
  details: "Value must be one of expected values",
  name: "in",
  expected: [
    ...n
  ].sort(),
  path: r.toArray(),
  value: e
}), G = ({ property: n, path: e }) => ({
  details: `The property "${n}" is not expected`,
  name: "unexpected",
  path: e.toArray()
}), m = ({ property: n, path: e }) => ({
  details: `The property "${n}" is required here`,
  name: "required",
  path: e.toArray()
});
class A {
  obj;
  path;
  _errors = [];
  constructor(e, r) {
    this.obj = e, this.path = r;
  }
  catch = (...e) => {
    this._errors.push(...e);
  };
  get errors() {
    const e = (r) => JSON.stringify({
      details: r.details,
      path: r.path
    });
    return this._errors.filter((r, s) => this._errors.findIndex((E) => e(r) === e(E)) === s);
  }
  exists = (e) => e in this.obj ? !0 : (this.catch(m({
    property: e,
    path: this.path.of(e)
  })), !1);
  object = (e) => {
    const r = e ? this.obj[e] : this.obj;
    if (e && !this.exists(e))
      return !1;
    if (typeof r == "object" && !Array.isArray(r) && r !== null)
      return !0;
    const s = e ? this.path.of(e) : this.path, E = e ?? this.path.last() ?? "value";
    return this.catch(T({
      typeName: "Object",
      property: E,
      path: s,
      value: r
    })), !1;
  };
  string = (e) => {
    const r = this.obj[e];
    return e && !this.exists(e) ? !1 : typeof r == "string" ? !0 : (this.catch(T({
      typeName: "String",
      property: e,
      path: this.path.of(e),
      value: r
    })), !1);
  };
  number = (e, r) => {
    const s = this.obj[e];
    return r && !(e in this.obj) ? !0 : this.exists(e) ? typeof s == "number" && !Number.isNaN(s) ? !0 : (this.catch(T({
      typeName: "Number",
      property: e,
      path: this.path.of(e),
      value: s
    })), !1) : !1;
  };
  array = (e) => {
    const r = this.obj[e];
    return e && !this.exists(e) ? !1 : Array.isArray(r) ? !0 : (this.catch(T({
      typeName: "Array",
      property: e,
      path: this.path.of(e),
      value: r
    })), !1);
  };
  enum = (e, r) => {
    const s = this.obj[e];
    return typeof s == "string" && r.includes(s) ? !0 : (this.catch(b({
      expected: r,
      value: s,
      path: this.path.of(e)
    })), !1);
  };
  empty = (e) => {
    if (!this.array(e))
      return !1;
    const r = this.obj[e];
    return r.length === 0 ? !0 : (this.catch(y({
      max: 0,
      value: r,
      path: this.path.of(e)
    })), !1);
  };
  minLength = (e, r) => {
    if (!this.array(e))
      return !1;
    const s = this.obj[e];
    return s.length >= r ? !0 : (this.catch(N({
      min: r,
      value: s,
      path: this.path.of(e)
    })), !1);
  };
  noAdditionalProperties = (e) => {
    const r = Object.keys(this.obj).sort().filter((s) => !e.includes(s));
    return r.forEach((s) => this.catch(G({
      property: s,
      path: this.path.of(s)
    }))), r.length === 0;
  };
  each = (e, r) => {
    if (!this.array(e))
      return;
    const s = this.obj[e];
    let E = !1;
    s.forEach((c, u) => {
      if (E)
        return;
      const l = r(c, this.path.of(e).of(u));
      l.length > 0 && (E = !0), this.catch(...l);
    });
  };
}
const _ = [];
class p {
  contentRule;
  validateData;
  constructor(e, r) {
    this.contentRule = e, this.validateData = r;
  }
  assert(e, r) {
    const s = new A(e, r);
    if (!s.object())
      return s.errors;
    s.noAdditionalProperties([
      "nodeType",
      "data",
      "content"
    ]);
    const { nodeTypes: E, min: c = 0 } = Array.isArray(this.contentRule) ? {
      nodeTypes: this.contentRule
    } : this.contentRule(e, r);
    if (E.length === 0 && c > 0)
      throw new Error(`Invalid content rule. Cannot have enforce a 'min' of ${c} with no nodeTypes`);
    if (s.minLength("content", c), E.length === 0 ? s.empty("content") : s.each("content", (u, l) => {
      const D = new A(u, l);
      return D.object() && D.enum("nodeType", E), D.errors;
    }), s.object("data")) {
      const u = this.validateData?.(e.data, r.of("data")) ?? [];
      s.catch(...u);
    }
    return s.errors;
  }
}
class P extends p {
  linkType;
  type;
  constructor(e, r) {
    super(r, (s, E) => this.assertLink(s, E)), this.linkType = e, this.type = this.linkType.startsWith("Contentful:") ? "ResourceLink" : "Link";
  }
  assertLink = (e, r) => {
    const s = new A(e, r);
    if (s.object("target")) {
      const E = new A(e.target.sys, r.of("target").of("sys"));
      E.object() && (E.enum("type", [
        this.type
      ]), E.enum("linkType", [
        this.linkType
      ]), this.type === "Link" ? (E.string("id"), E.noAdditionalProperties([
        "type",
        "linkType",
        "id"
      ])) : this.type === "ResourceLink" && (E.string("urn"), E.noAdditionalProperties([
        "type",
        "linkType",
        "urn"
      ]))), s.catch(...E.errors);
    }
    return s.noAdditionalProperties([
      "target"
    ]), s.errors;
  };
}
class S extends p {
  constructor() {
    super([
      "text"
    ], (e, r) => this.assertLink(e, r));
  }
  assertLink = (e, r) => {
    const s = new A(e, r);
    return s.string("uri"), s.noAdditionalProperties([
      "uri"
    ]), s.errors;
  };
}
const o = (n, e) => new p(n, e), h = (n, e) => new P(n, e), a = o([
  ...Object.values(i),
  "text"
].sort()), L = o([
  t.LIST_ITEM
]), M = h("Entry", _), R = o(() => ({
  nodeTypes: [
    t.PARAGRAPH
  ],
  min: 1
}), (n, e) => {
  const r = new A(n, e);
  return r.noAdditionalProperties([
    "colspan",
    "rowspan"
  ]), r.number("colspan", !0), r.number("rowspan", !0), r.errors;
});
t.DOCUMENT + "", o(f), t.PARAGRAPH + "", t.HEADING_1 + "", t.HEADING_2 + "", t.HEADING_3 + "", t.HEADING_4 + "", t.HEADING_5 + "", t.HEADING_6 + "", t.QUOTE + "", o(I[t.QUOTE]), t.EMBEDDED_ENTRY + "", t.EMBEDDED_ASSET + "", h("Asset", _), t.EMBEDDED_RESOURCE + "", h("Contentful:Entry", _), t.HR + "", o(_), t.OL_LIST + "", t.UL_LIST + "", t.LIST_ITEM + "", o([
  ...d
].sort()), t.TABLE + "", o(() => ({
  nodeTypes: [
    t.TABLE_ROW
  ],
  min: 1
})), t.TABLE_ROW + "", o(() => ({
  nodeTypes: [
    t.TABLE_CELL,
    t.TABLE_HEADER_CELL
  ],
  min: 1
})), t.TABLE_CELL + "", t.TABLE_HEADER_CELL + "", i.HYPERLINK + "", new S(), i.EMBEDDED_RESOURCE + "", h("Contentful:Entry", _), i.ENTRY_HYPERLINK + "", h("Entry", [
  "text"
]), i.ASSET_HYPERLINK + "", h("Asset", [
  "text"
]), i.RESOURCE_HYPERLINK + "", h("Contentful:Entry", [
  "text"
]);
export {
  t as B
};
